<div class="install-notification-wrapper" *ngIf="showIosInstallNotification">
  <div class="install-notification mat-elevation-z8">
    <div class="install-message">
      {{ 'pwa.install_notification_ios.message1' | translate }} <img src="/assets/img/ios-share-white.svg" alt="">
      {{ 'pwa.install_notification_ios.message2' | translate }}
    </div>
    <button mat-flat-button (click)="onCloseNotification()">
      {{ 'pwa.not_now_button' | translate }}
    </button>
    <!-- <i class="material-icons" (click)="onCloseNotification()">close</i> -->
  </div>
</div>

<div class="install-notification-wrapper" *ngIf="showAndroidInstallNotification && !disableAndroidInstalationNotification">
  <div class="install-notification mat-elevation-z8">
    <div class="install-message">
      {{ 'pwa.install_notification_android.message' | translate }}
    </div>
    <button mat-flat-button (click)="installPwaOnAndroid()">
      {{ 'pwa.install_notification_android.install_button' | translate }}
    </button>
    <button mat-button (click)="onCloseNotification()">
      {{ 'pwa.not_now_button' | translate }}
    </button>
  </div>
</div>

<div class="install-notification-wrapper" *ngIf="showAndroidAfterInstallNotification">
  <div class="install-notification mat-elevation-z8">
    <div class="install-message">
      {{ 'pwa.install_notification_android.app_installed' | translate }}
    </div>
    <button mat-flat-button (click)="onCloseNotification()">
      {{ 'pwa.ok_button' | translate }}
    </button>
    <!-- <button mat-icon-button  (click)="onCloseNotification()">
      <mat-icon>close</mat-icon>
    </button> -->
    <!-- <a mat-flat-button [href]="crurrentDomain" target="_blank">{{ 'pwa.install_notification_android.open_app' | translate }}</a> -->
  </div>
</div>